(function () {
  if (window.__canopyCartPage) return;
  window.__canopyCartPage = true;

  var positioning = false;

  function offerLabel(text) {
    var label = (text || '').trim();
    var percent = label.match(/^(\d+(?:\.\d+)?)%\s*off$/i);
    if (percent) return 'Save ' + percent[1] + '%';
    return label;
  }

  function alignOfferChip(wrap) {
    var chip = wrap.querySelector('.cart__essentials-offer');
    var green = wrap.querySelector('.canopy-upsell');
    var card = wrap.querySelector('.canopy-upsell__card');
    var track = wrap.querySelector('.canopy-upsell__grid');
    if (!chip || !green || !card || !track) return;

    var wrapRect = wrap.getBoundingClientRect();
    var greenRect = green.getBoundingClientRect();
    var cardRect = card.getBoundingClientRect();
    var trackRect = track.getBoundingClientRect();
    var visibleRight = Math.min(trackRect.right, trackRect.left + track.clientWidth);
    var bandTop = greenRect.top;
    var bandBottom = cardRect.top;
    var mid = bandTop + Math.max(bandBottom - bandTop, 0) / 2;

    chip.style.right = Math.max(0, wrapRect.right - visibleRight) + 'px';
    chip.style.top = Math.max(0, mid - wrapRect.top - chip.offsetHeight / 2) + 'px';
  }

  function activeCard(track) {
    var cards = track.querySelectorAll('.canopy-upsell__card');
    if (!cards.length) return null;
    var left = track.getBoundingClientRect().left;
    var best = cards[0];
    var bestDist = Infinity;
    Array.prototype.forEach.call(cards, function (card) {
      var dist = Math.abs(card.getBoundingClientRect().left - left);
      if (dist < bestDist) {
        bestDist = dist;
        best = card;
      }
    });
    return best;
  }

  function placeOfferChips(root) {
    if (positioning) return;
    positioning = true;
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.cart__essentials-offer-wrap').forEach(function (wrap) {
      var green = wrap.querySelector('.canopy-upsell');
      var track = wrap.querySelector('[data-canopy-track]') || wrap.querySelector('.canopy-upsell__grid');
      if (!green || !track) return;

      var card = activeCard(track);
      var badge = card && card.querySelector('.canopy-upsell__badge');
      var nextLabel = badge ? offerLabel(badge.textContent) : '';

      var chip = wrap.querySelector('.cart__essentials-offer');
      if (!nextLabel) {
        if (chip) chip.hidden = true;
        return;
      }

      if (!chip) {
        chip = document.createElement('p');
        chip.className = 'cart__essentials-offer';
      }
      if (chip.parentElement !== green) green.insertBefore(chip, green.firstChild);
      chip.hidden = false;
      if (chip.textContent !== nextLabel) chip.textContent = nextLabel;

      wrap.querySelectorAll('.canopy-upsell__badge').forEach(function (item) {
        if (!item.hidden) item.hidden = true;
      });
      alignOfferChip(wrap);
      watchTrack(track, wrap);
    });
    positioning = false;
  }

  function watchTrack(track, wrap) {
    if (track.dataset.canopyOfferWatch === 'true') return;
    track.dataset.canopyOfferWatch = 'true';
    var frame = 0;
    track.addEventListener('scroll', function () {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        placeOfferChips(wrap);
      });
    }, { passive: true });
  }

  function watchEssentials() {
    document.querySelectorAll('.cart__essentials').forEach(function (essentials) {
      if (essentials.dataset.canopyWatch === 'true') return;
      essentials.dataset.canopyWatch = 'true';
      var observer = new MutationObserver(function () {
        if (positioning) return;
        placeOfferChips(essentials);
      });
      observer.observe(essentials, { childList: true, subtree: true });
    });
  }

  window.canopyPlaceOfferChips = function (root) {
    placeOfferChips(root || document);
    watchEssentials();
  };

  function start() {
    placeOfferChips(document);
    watchEssentials();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('resize', function () {
    placeOfferChips(document.getElementById('cart-essentials') || document);
  });
})();
